import { render, staticRenderFns } from "./GifLoading.vue?vue&type=template&id=9ba56ffa&scoped=true"
import script from "./GifLoading.vue?vue&type=script&lang=js"
export * from "./GifLoading.vue?vue&type=script&lang=js"
import style0 from "./GifLoading.vue?vue&type=style&index=0&id=9ba56ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba56ffa",
  null
  
)

export default component.exports